import Login from '../views/authentication/login';
import SignUp from '../views/authentication/signUp';

var authRoutes = [
    { path: '/authentication/login', name: 'Login', icon: 'mdi mdi-account-key', component: Login },
    { path: '/authentication/signup', name: 'Sign Up', icon: 'mdi mdi-account-key', component: SignUp }
];
export default authRoutes; 